import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animated-check',
  templateUrl: './animated-check.component.html',
  styleUrls: ['./animated-check.component.scss']
})
export class AnimatedCheckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
